import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import Platform from '../shared/Platform';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';

export default function ProfessionalPresence({ professionalPresence, biData }) {
    if (!professionalPresence.length) { return null; }

    const seller_card_about_me_professional_presence_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_professional_presence_impression',
        data: professionalPresence
    });

    return (
        <WithImpressions value={seller_card_about_me_professional_presence_impression} className="social-media-platforms">
            <h3><I18n k="user_page_perseus.seller_profile.professional_presence"/></h3>
            <ul>
                {professionalPresence.map((platform, idx) =>
                    <Platform platformData={platform} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

ProfessionalPresence.propTypes = {
    professionalPresence: PropTypes.array,
    biData: PropTypes.object
};

ProfessionalPresence.defaultProps = {
    professionalPresence: [],
    biData: {}
};
